module.exports = "/images/google_maps.svg";